/** Enter 登录链路使用的客户端关联 ID；仅用于观测，不承载业务数据。 */
export function createEnterAuthTraceId(): string {
  return crypto.randomUUID();
}

/** 将链路 ID 放进最终业务地址，跨页面只依赖 URL 串联。 */
export function appendEnterAuthTraceId(
  path: string,
  authTraceId: string | undefined,
  origin: string
): string {
  if (!authTraceId) return path;
  const url = new URL(path, origin);
  url.searchParams.set('auth_trace_id', authTraceId);
  return `${url.pathname}${url.search}${url.hash}`;
}
